import React from 'react';

const TelegramIcon = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    className,
    style: { ...style, overflow: "visible" },
    width: "17",
    height: "14",
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M4.15417 8.09789L5.93379 13.0236C5.93379 13.0236 6.15629 13.4845 6.39454 13.4845C6.63279 13.4845 10.1764 9.79802 10.1764 9.79802L14.117 2.18677L4.21767 6.82639L4.15417 8.09789Z",
      fill: "#C8DAEA"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M6.51174 9.3606L6.16987 12.9939C6.16987 12.9939 6.02677 14.1072 7.13981 12.9939C8.25285 11.8806 9.31823 11.0221 9.31823 11.0221",
      fill: "#A9C6D8"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M4.18454 8.2726L0.523793 7.07985C0.523793 7.07985 0.0862927 6.90236 0.227168 6.49986C0.256168 6.41686 0.314667 6.34623 0.489667 6.22485C1.30079 5.65948 15.5029 0.554855 15.5029 0.554855C15.5029 0.554855 15.9039 0.419731 16.1404 0.509606C16.1989 0.527716 16.2516 0.561044 16.293 0.606177C16.3344 0.651311 16.363 0.706631 16.376 0.766481C16.4016 0.872189 16.4123 0.980945 16.4078 1.08961C16.4067 1.18361 16.3953 1.27073 16.3867 1.40736C16.3002 2.80298 13.7117 13.219 13.7117 13.219C13.7117 13.219 13.5568 13.8285 13.0019 13.8494C12.8656 13.8538 12.7297 13.8307 12.6025 13.7814C12.4752 13.7322 12.3592 13.6579 12.2613 13.5629C11.1724 12.6262 7.40892 10.097 6.57729 9.54073C6.55853 9.52795 6.54274 9.51129 6.53096 9.49188C6.51919 9.47248 6.51171 9.45077 6.50904 9.42823C6.49742 9.36961 6.56117 9.29698 6.56117 9.29698C6.56117 9.29698 13.1144 3.47198 13.2888 2.86048C13.3023 2.81311 13.2513 2.78973 13.1828 2.81048C12.7475 2.97061 5.20229 7.73548 4.36954 8.26135C4.3096 8.27949 4.24624 8.28334 4.18454 8.2726Z",
      fill: "white"
    }
  )
);
TelegramIcon.displayName = "Icons.TelegramIcon";

export { TelegramIcon };
//# sourceMappingURL=TelegramIcon.js.map
